
import axios from "axios";

const overrideBaseURL = sessionStorage.getItem('baseURL');
const computedBaseURL = overrideBaseURL
  ? overrideBaseURL
  : (process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_DEV_MODE_URL
      : process.env.REACT_APP_PRO_MODE_URL);

export default axios.create({
    baseURL: `${computedBaseURL}`,
    headers: {
        "Content-type": "application/json",
        "Authorization": `Bearer ${JSON.parse(sessionStorage.getItem('token'))}`
    }
});

